import { API_BASE_URL, API_SERVER_URL } from "../config/api";
import { fetchWithToken } from "../services/api";

export type RegionSettings = {
  id: number;
  region: string;
  mysterySlabsEnabled: boolean;
  /** HQ's per-office switch for the defect points engine (D6, spec §5.6). Off by default;
   *  when off the grading screen keeps the legacy cap/count report (ENG-11). */
  defectPointsEnabled: boolean;
  autoPrintOnEntry: boolean;
  autoLogoutEnabled: boolean;
  /** When on, registering a mystery slab opens the grade-entry modal; when off,
   *  registering just prints the barcode and the score is a separate checkpoint. */
  gradeEntryOnRegister: boolean;
  manualQuantityEnabled: boolean;
  manualLanguageSelectionEnabled: boolean;
  manualSportsCardEnabled: boolean;
  multiSlabAcknowledgementEnabled: boolean;
  managedServiceCardsEnabled: boolean;
  optionalInsuranceEnabled: boolean;
  /** Staged storefront rollout for Shopify's signed app-proxy cart transport. */
  secureCartProxyEnabled: boolean;
  /** JAN-style order barcodes: the order-level barcode becomes the 13-digit
   *  zero-padded order number (0000000002979) instead of order+item blocks.
   *  Item barcodes keep the standard layout either way. */
  leadingZeroOrderBarcodesEnabled: boolean;
  /** Centered Nest (changeset 226), set by HQ on the Labelling page, not here: whether this
   *  office's label stations may use it, and whether they start with it on. Null = off. */
  centeredNestAvailable?: boolean | null;
  centeredNestDefault?: boolean | null;
};

/** Get settings for the current region (determined by hostname) */
export const fetchRegionSettings = (): Promise<RegionSettings> =>
  fetchWithToken({
    method: "GET",
    endpoint: `${API_BASE_URL}/settings`,
  });

/** Get settings for all regions (Super Admin only) */
export const fetchAllRegionSettings = (): Promise<RegionSettings[]> =>
  fetchWithToken({
    method: "GET",
    endpoint: `${API_BASE_URL}/settings/all`,
  });

/** Update settings for a specific region (Super Admin only) */
export const updateRegionSettings = (
  region: string,
  settings: Partial<RegionSettings>
): Promise<RegionSettings> =>
  fetchWithToken({
    method: "PUT",
    endpoint: `${API_BASE_URL}/settings/${region}`,
    payload: settings,
  });
